import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import bhareeLogo from "../../assets/images/bhareeLogo.png";
import TruckImage from "../../assets/images/Homepagetruck.png";
import DownArrowHeadIcon from "../../assets/images/downArrowHead.png";
import SellerToBuyer from "../../assets/images/Seller-to-buyer-banner.png";

import QuoteSection from "../common/QuoteSection";
import "react-image-gallery/styles/css/image-gallery.css";
import "./about-us.css";
import { useDispatch, useSelector } from "react-redux";
import BuyerAuth from "../auth/BuyerAuth";
import CityPopup from "../auth/CityPopup";

import { CarouselLeftArrow, CarouselRightArrow } from "../../assets/svg/svg-icons";
import Carousel from "react-multi-carousel";
import { getApi } from "../../actions/structure.action";

const AboutUs = () => {
  const ref = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { brands, auth } = useSelector((state) => {
    return state;
  });

  const CustomArrow = (e, variant, value) => {
    if (value === "left") {
      document.querySelector(`._${variant} .react-multiple-carousel__arrow--left`).click();
    } else if (value === "right") {
      document.querySelector(`._${variant} .react-multiple-carousel__arrow--right`).click();
    }
  };
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2.5,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1.5,
    },
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    getApi("getBuyerBrands", dispatch);
  }, [dispatch]);

  const handleScrollView = () => {
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  const AboutUsBanner = (
    <>
      <div className="about-us-banner">
        <div className="about-us-banner-background"></div>
        <Container>
          <Row className=" about-us-banner-content desktop">
            <Col xs={12} sm={12} md={9} className="about-banner-col">
              <h1>{"India’s First Online B2B Platform For Mineral Water"}</h1>
              {/* <h6>{"your mineral water online platform,"}</h6> */}
              <p>
                {
                  "The ultimate online platform for high-quality mineral water products, connecting buyers and suppliers from around the Nation!"
                }
              </p>
              <span className="arrow-scroll" onClick={() => handleScrollView()}>
                <Image src={DownArrowHeadIcon} alt="DownArrowHeadIcon" /> Scroll
              </span>
              <Image src={TruckImage} alt="TruckImage" className="bharee-truck" />
            </Col>
          </Row>
          <Row className=" about-us-banner-content mobile">
            <Col xs={12} className="about-banner-col">
              <h1>{"India’s First Online B2B Platform For Mineral Water"}</h1>
              {/* <h6>{"your mineral water online platform,"}</h6> */}
              <Image src={TruckImage} alt="TruckImage" style={{ width: "65%" }} />
            </Col>
            <Col xs={12} className="about-banner-col right">
              <p>
                {
                  "The ultimate online platform for high-quality mineral water products, connecting buyers and suppliers from around the Nation!"
                }
              </p>
              <span className="arrow-scroll" onClick={() => handleScrollView()}>
                <Image src={DownArrowHeadIcon} alt="DownArrowHeadIcon" /> Scroll
              </span>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );

  const WeConnect = (
    <>
      <Container className="we-connect-section" ref={ref}>
        <h4 className="section-title-we-connect">
          {"We Connect "}
          <span>
            {"the India’s leading "}
            <br />
            {"brands with largest retailer network"}
          </span>
        </h4>
      </Container>
      <Image className="we-connect-section-img" src={SellerToBuyer} style={{ maxWidth: "100%" }} />
    </>
  );

  const [showCityModal, setShowCityModal] = useState(false);

  const BuyerSellerSection = (
    <div className="buyer-seller-section">
      <Container>
        <Row className="m-0 pb-0">
          <Col xs={12} sm={12} md={6} className="seller">
            <Row>
              <Col xs={12} sm={12} md={12} lg={6}>
                <h3>{"Sellers"}</h3>
                <p>
                  {
                    "Bharee platform empowers both suppliers and buyers by providing a powerful platform to showcase products, create product listings, manage orders, and receive payments securely, all while offering a range of tools and resources to help seller grow their business."
                  }
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} className="image-col">
                {/* <iframe src="https://www.youtube.com/embed/0H0g_uy8Ik0?loop=1&iv_load_policy=3&disablekb=1&fs=0&color=white" width="275" height="185" frameborder="0"></iframe> */}
                <iframe
                  width="275"
                  height="185"
                  src="https://www.youtube.com/embed/0H0g_uy8Ik0?si=unMPFS6idFWeW9-v"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
                {/* <Image src={Laptop} /> */}
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} className="button-col">
                {auth?.loggedIn ? (
                  <Link to="/seller/profile-panel" className="section-link">
                    {"Become A Seller"}
                  </Link>
                ) : (
                  <>
                    <CityPopup show={showCityModal} onHide={() => setShowCityModal(false)} />
                    <Button
                      className="btn btn-primary section-link"
                      onClick={() => {
                        // setShowCityModal(true);
                        navigate("/seller/subscription/generic");
                      }}
                    >
                      {"Become A Seller"}
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={6} className="buyer">
            <Row>
              <Col xs={12} sm={12} md={12} lg={6}>
                <h3>{"Buyers"}</h3>
                <p>
                  {
                    "Experience the assurance of genuine and high-quality mineral water products at Bharee, as we verify all our suppliers to bring you transparency and reliability. Discover a vast selection of mineral water products at competitive prices with Bharee's comprehensive product listing, catering to all your preferences and needs."
                  }
                </p>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} className="image-col">
                <iframe
                  width="275"
                  height="185"
                  src="https://www.youtube.com/embed/h-HNSGlbISA?si=PYKt6d0Pk1NTsvPG"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </Col>
              <Col xs={12} sm={12} md={12} lg={6} className="button-col">
                {auth?.loggedIn ? (
                  <Link to="/" className="section-link">
                    {"Order Now"}
                  </Link>
                ) : (
                  <BuyerAuth
                    registerMode={true}
                    buttonText={"Register Now"}
                    buttonClasses={"section-link"}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );

  const BrandsSection = (
    <Container className="py-5">
      <Row className="m-0 mb-3">
        <Col xs={12} sm={12} md={12} lg={6} className="brand-section-title-logo-col">
          <Image src={bhareeLogo} alt="bhareeLogo" />
        </Col>
        <Col xs={12} sm={12} md={12} lg={6} className="brand-section-title-text-col">
          <h4>{" works with best brands"}</h4>
        </Col>
      </Row>
      {brands?.data?.length > 0 && brands?.data?.length < 5 && (
        <Row className="brand-row m-0 w-100">
          {brands?.data.map((brand, index) => {
            return (
              index < 4 && (
                <Col key={brand.id + "_" + index} className="mb-4" xs={6} sm={6} md={3}>
                  <div
                    className="brand-card bg-white"
                    onClick={() => navigate(`/brands?brand=${brand.brand_name + "|" + brand.id}`)}
                  >
                    <Image src={brand.brand_logo} alt={brand.brand_name} />
                    <p className="text-uppercase">{brand.brand_name}</p>
                  </div>
                </Col>
              )
            );
          })}
        </Row>
      )}
      {brands?.data?.length > 0 && brands?.data?.length > 4 && (
        <Row className="brand-row m-0 w-100">
          <Row className="dealOfTheday-row m-0 " style={{ width: "100%" }}>
            <Col xs={0} sm={0} md={1} className="dealOfTheDay-carousel-arrow">
              <Button
                className="carousel-arrow-btn"
                onClick={(e) => {
                  CustomArrow(e, "brands_carousel", "left");
                }}
              >
                <CarouselLeftArrow />
              </Button>
            </Col>
            <Col xs={12} sm={12} md={10} className="p-0">
              <Container fluid="sm" className="p-0">
                <Carousel
                  className="_brands_carousel"
                  swipeable={true}
                  draggable={false}
                  showDots={true}
                  responsive={responsive}
                  // ssr={true} // means to render carousel on server-side.
                  infinite={true}
                  // autoPlay={this.props.deviceType !== "mobile" ? true : false}
                  autoPlay={true}
                  // autoPlaySpeed={2000}
                  keyBoardControl={true}
                  customTransition="transform 0.5s ease-in-out 0s"
                  // transitionDuration={500}
                  // containerClass="carousel-container"
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  // deviceType={this.props.deviceType}
                  dotListClass="custom-dot-list-style"
                  // itemClass="carousel-item-padding-40-px"
                >
                  {brands?.data.map((brand, index) => (
                    <div key={brand.id + "_" + index + 1} className="me-4 h-100">
                      <div
                        className="brand-card bg-white"
                        onClick={() =>
                          navigate(`/brands?brand=${brand.brand_name + "|" + brand.id}`)
                        }
                      >
                        <Image src={brand.brand_logo} alt={brand.brand_name} />
                        <p className="text-uppercase">{brand.brand_name}</p>
                      </div>
                    </div>
                  ))}
                </Carousel>
              </Container>
            </Col>
            <Col xs={0} sm={0} md={1} className="dealOfTheDay-carousel-arrow">
              <Button
                className="carousel-arrow-btn"
                onClick={(e) => {
                  CustomArrow(e, "brands_carousel", "right");
                }}
              >
                <CarouselRightArrow />
              </Button>
            </Col>
          </Row>
        </Row>
      )}
    </Container>
  );

  return (
    <section>
      {AboutUsBanner}
      {WeConnect}
      {BuyerSellerSection}
      {BrandsSection}
      <QuoteSection text={"Let's explore the limitless online market for your brand."} />
    </section>
  );
};

export default AboutUs;
